import { CheckboxCard, IconButton, IconButtonSize } from "shared/components";
import { DocType } from "../types";
import { Dispatch, SetStateAction } from "react";
import { cx } from "shared/utils";
import { HugeiconsIcon, HugeiconsIconProps } from "@hugeicons/react";
import { Radio } from "shared/components/forms/Radio";
import {
  Briefcase01Icon,
  Cancel01Icon,
  PieChartIcon
} from "@hugeicons-pro/core-stroke-rounded";
const Label = ({
  name,
  icon,
  selected
}: {
  name: string;
  selected: boolean;
  icon: HugeiconsIconProps["icon"];
}) => {
  return (
    <div className="flex gap-4 items-center">
      <div
        className={cx(
          "h-10 w-10 shrink-0 rounded-lg transition-all flex items-center justify-center",
          selected
            ? "bg-primary-50 text-primary-500"
            : "text-content-200 bg-alpha-40"
        )}
      >
        <HugeiconsIcon icon={icon} size={20} />
      </div>

      <p className="text-base text-content-1000 font-bold">{name}</p>

      <Radio id={name} className="ml-auto" name={name} checked={selected} />
    </div>
  );
};

export const DocTypeView = ({
  docType,
  setDocType,
  applicantFullName,
  onClose
}: {
  docType: DocType;
  setDocType: Dispatch<SetStateAction<DocType>>;
  applicantFullName: string;
  onClose?: () => void;
}) => {
  return (
    <div className="flex flex-col h-full">
      <header className="p-6 border-b border-alpha-100">
        <h1 className="text-xl text-content-1000 font-bold mb-1 relative">
          Select document type
          <IconButton
            HugeIcon={Cancel01Icon}
            size={IconButtonSize.SM}
            borderLess
            className="absolute -top-2 -right-2"
            onClick={onClose}
          />
        </h1>

        <p className="text-sm font-medium text-content-400">
          Select document type to verify {applicantFullName}&apos;s income
        </p>
      </header>
      <div className="flex-grow bg-background-900 p-6 h-full space-y-3">
        <CheckboxCard
          id="docType_paystub"
          name="paystub"
          className="!border !border-alpha-100"
          label={
            <Label
              selected={docType === DocType.Paystub}
              name="Pay stubs"
              icon={Briefcase01Icon}
            />
          }
          value="paystub"
          checked={docType === DocType.Paystub}
          onChange={() => {
            setDocType(DocType.Paystub);
          }}
        />
        <CheckboxCard
          id="docType_w2"
          name="w2"
          className="!border !border-alpha-100"
          label={
            <Label
              name="W2"
              selected={docType === DocType.W2}
              icon={PieChartIcon}
            />
          }
          value="w2"
          checked={docType === DocType.W2}
          onChange={() => {
            setDocType(DocType.W2);
          }}
        />
      </div>
    </div>
  );
};
